import { useOrder } from "../../../hooks/api/v2/order/useOrder";
import { useSupplierRelationshipList } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipList";
import { useParamAsNumber } from "../../../hooks/useParamAsNumber";
import { CREATE_CONSIGNMENT } from "../../../constants/routes";
import { SpinnerLegacy } from "../..";
import { OrderCreateConsignmentUps } from "./OrderCreateConsignmentUps";

export const OrderCreateConsignmentType = () => {
  const orderId = useParamAsNumber(CREATE_CONSIGNMENT, "orderId");
  const orderQuery = useOrder(orderId);

  const supplierRelationshipQuery = useSupplierRelationshipList(
    {
      query: [
        {
          type: "buyerId",
          modifier: "EQUALS",
          value: orderQuery.data?.RetailerId ?? 0,
        },
      ],
      limit: 1,
    },

    {
      enabled: !!orderQuery.data?.RetailerId,
    },
  );

  if (
    supplierRelationshipQuery.isPending ||
    orderQuery.isPending ||
    !orderQuery.data
  ) {
    return <SpinnerLegacy />;
  }

  return <OrderCreateConsignmentUps order={orderQuery.data} />;
};
